import createIcon from '../../createIcon';

/**
 * @component @name SportsHandball
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuMjczNyA1LjU0MDY3QzEzLjcyMzcgNi40OTA2NyAxNC4wNTM3IDcuNzIwNjcgMTUuMDAzNyA4LjI3MDY3QzE1Ljk1MzcgOC44MjA2NyAxNy4xODM3IDguNDkwNjcgMTcuNzMzNyA3LjU0MDY3QzE4LjI4MzcgNi41OTA2NyAxNy45NTM3IDUuMzYwNjcgMTcuMDAzNyA0LjgxMDY3QzE2LjA1MzcgNC4yNjA2NyAxNC44MjM3IDQuNTkwNjcgMTQuMjczNyA1LjU0MDY3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1Ljg0MzcgOS45NTA2N0MxNS44NDM3IDkuOTUwNjcgMTQuMjEzNyA5LjAxMDY3IDEzLjI0MzcgOC40NTA2N0MxMC44NjM3IDcuMDcwNjcgMTAuMDQzNyA0LjAxMDY3IDExLjQyMzcgMS42MzA2N0w5LjY5MzY3IDAuNjMwNjdDOC4xMDM2NyAzLjM3MDY3IDguNjAzNjcgNi43NTA2NyAxMC42NjM3IDguOTQwNjdMNS41MTM2NyAxNy44NjA3TDcuMjQzNjcgMTguODYwN0w4Ljc0MzY3IDE2LjI2MDdMMTAuNDczNyAxNy4yNjA3TDcuNDczNjcgMjIuNDYwN0w5LjIwMzY3IDIzLjQ2MDdMMTUuNDkzNyAxMi41NzA3QzE2LjYzMzcgMTQuMTIwNyAxNi44MjM3IDE2LjI2MDcgMTUuODAzNyAxOC4wMzA3TDE3LjUzMzcgMTkuMDMwN0MxOS4xMzM3IDE2LjI4MDcgMTguODEzNyAxMi40NTA3IDE1Ljg0MzcgOS45NTA2N1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMi43NTM3IDMuMzQwNjdDMTMuNDczNyAzLjc1MDY3IDE0LjM4MzcgMy41MTA2NyAxNC44MDM3IDIuNzkwNjdDMTUuMjEzNyAyLjA3MDY3IDE0Ljk3MzcgMS4xNjA2NyAxNC4yNTM3IDAuNzQwNjdDMTMuNTMzNyAwLjMzMDY3IDEyLjYyMzcgMC41NzA2NyAxMi4yMDM3IDEuMjkwNjdDMTEuNzkzNyAyLjAxMDY3IDEyLjAzMzcgMi45MzA2NyAxMi43NTM3IDMuMzQwNjdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsHandball = createIcon('SportsHandball', [
  [
    'path',
    {
      d: 'M14.2737 5.54067C13.7237 6.49067 14.0537 7.72067 15.0037 8.27067C15.9537 8.82067 17.1837 8.49067 17.7337 7.54067C18.2837 6.59067 17.9537 5.36067 17.0037 4.81067C16.0537 4.26067 14.8237 4.59067 14.2737 5.54067Z',
      key: '17c2lr',
    },
  ],
  [
    'path',
    {
      d: 'M15.8437 9.95067C15.8437 9.95067 14.2137 9.01067 13.2437 8.45067C10.8637 7.07067 10.0437 4.01067 11.4237 1.63067L9.69367 0.63067C8.10367 3.37067 8.60367 6.75067 10.6637 8.94067L5.51367 17.8607L7.24367 18.8607L8.74367 16.2607L10.4737 17.2607L7.47367 22.4607L9.20367 23.4607L15.4937 12.5707C16.6337 14.1207 16.8237 16.2607 15.8037 18.0307L17.5337 19.0307C19.1337 16.2807 18.8137 12.4507 15.8437 9.95067Z',
      key: 'ut3ji4',
    },
  ],
  [
    'path',
    {
      d: 'M12.7537 3.34067C13.4737 3.75067 14.3837 3.51067 14.8037 2.79067C15.2137 2.07067 14.9737 1.16067 14.2537 0.74067C13.5337 0.33067 12.6237 0.57067 12.2037 1.29067C11.7937 2.01067 12.0337 2.93067 12.7537 3.34067Z',
      key: 'n8uoov',
    },
  ],
]);

export default SportsHandball;
